export { showApiError } from "./showApiError";
export type { ShowApiErrorOptions } from "./showApiError";
export {
  resolveFriendlyError,
  type FriendlyError,
  type ApiErrorLike,
} from "./errorCatalog";

import { resolveFriendlyError } from "./errorCatalog";
import { audienceOf, getCurrentUser } from "@/lib/auth/currentUser";

export function friendlyMessage(
  input: unknown,
  fallback?: string,
): string {
  return resolveFriendlyError(
    input as Parameters<typeof resolveFriendlyError>[0],
    fallback ? { description: fallback } : undefined,
    audienceOf(getCurrentUser()),
  ).description;
}
